<template>
  <div>
    <div class="page-header">
      <div class="page-header-left">
        <ol class="breadcrumb ml-0">
          <li class="breadcrumb-item">
            <router-link :to="{ name: 'welcome' }">
              <feather type="home" />
            </router-link>
          </li>
          <li class="breadcrumb-item">
            <router-link :to="{ name: 'vendorManagementDashboard' }">
              {{ $t('companyFormAdminView.vendorManagement') }}
            </router-link>
          </li>
          <li class="breadcrumb-item">
            {{ $t('companyVendors.tsdiqlnmiTdarklr') }}
          </li>
        </ol>
      </div>
      <h4 class="my-3">
        {{ $t('companyVendors.tsdiqlnmiTdarklr') }}
      </h4>
    </div>

    <div v-if="!loaded">
      <div class="alert alert-primary">
        {{ $t('companyFormAdminView.mlumatYklnir') }}
      </div>
    </div>
    <div v-else>
      <div class="card">
        <div class="card-header">
          <div class="row">
            <div class="col-md-5">
              <select
                v-model="profileTypeFilter"
                class="form-control"
                required
              >
                <option value="ALL">
                  {{ $t('companyVendors.btnProfillr') }}
                </option>
                <option value="SUPPLIER">
                  {{ $t('companyFormEdit.malVXidmtlrlBal') }}
                </option>
                <option value="LOGISTIC">
                  {{ $t('companyFormEdit.logistiklrN') }}
                </option>
                <option value="TRUCK">
                  {{ $t('companyFormEdit.trSahiblriN') }}
                </option>
              </select>
            </div>
            <div
              v-if="profileTypeFilter==='SUPPLIER' || profileTypeFilter ==='ALL'"
              class="col-md-5"
            >
              <select
                v-model.number="sectorFilter"
                class="form-control"
              >
                <option value="0">
                  {{ $t('companyVendors.btnSektorlar') }}
                </option>
                <option
                  v-for="s in sectorList"
                  :value="s.id"
                >
                  {{ s.name }}
                </option>
              </select>
            </div>

            <div class="col-md-2 text-right">
              <button
                class="btn btn-primary"
                @click="addVendorToList"
              >
                Bir başa vendor listə əlavə et
              </button>
            </div>
          </div>
          <div class="row mt-2">
            <div class="col-md-6">
              <input
                v-model="vendorNameFilter"
                type="text"
                class="form-control"
                placeholder="Vendor adını filterləyin"
              >
            </div>
            <div class="col-md-6">
              <select
                v-model="vendorSortOrder"
                class="form-control"
              >
                <option value="asc">
                  A–Z
                </option>
                <option value="desc">
                  Z–A
                </option>
              </select>
            </div>
          </div>
        </div>
        <div class="list-group list-group-flush">
          <div
            v-if="filteredVendors.length<1"
            class="list-group-item"
          >
            <div v-if="sectorFilter>0 || profileTypeFilter !=='ALL'">
              {{ $t('companyVendors.axtraraUyunNticTaplmad') }}
            </div>
            <div v-else>
              {{ $t('companyVendors.tsdiqlnmiTdarkYoxdur') }}
            </div>
          </div>
          <div
            v-for="v in filteredVendors"
            :key="v.verifiedCompany.taxId"
            class="list-group-item"
          >
            <!-- 1-ci sətir -->
            <div class="row">
              <!-- 1) Şirkət adı və VÖEN -->
              <div class="col-md-4 mb-3">
                <strong>
                  {{ v.verifiedCompany.name }}
                  {{ getCompanyFormat(v.verifiedCompany.format) }}
                </strong>
                <br>
                {{ $t('supplierOutgoingVendorRequest.ven') }}
                <em>{{ v.verifiedCompany.taxId }}</em>
              </div>

              <!-- 2) Profile type və sektorlar -->
              <div class="col-md-4 mb-3">
                <div v-if="v.profileType === 'LOGISTIC'">
                  {{ $t('companyVendors.logistikSorularNTsdiqlnmidir') }}
                </div>
                <div v-if="v.profileType === 'TRUCK'">
                  {{ $t('companyVendors.trlarlaBalSorularNTsdiqlnmidir') }}
                </div>
                <div
                  v-for="s in v.sectors"
                  :key="s.sector.id"
                >
                  <span
                    :class="{
                      'font-weight-bold':
                        sectorFilter > 0 && sectorFilter === s.sector.id
                    }"
                  >
                    - {{ s.sector.name }}
                  </span>
                  <a
                    v-if="s.companyFormRequest"
                    href="#"
                    @click.prevent="showRequestDetails(s.companyFormRequest.id)"
                  >
                    {{
                      $t('supplierOutgoingVendorRequest.mracit', {
                        id: s.companyFormRequest.id
                      })
                    }}
                  </a>
                </div>
              </div>

              <!-- 3) Tarixi dəyiş düyməsi -->
              <div class="col-md-1 text-left">
                <!-- Əgər formRequest varsa -->
                <template v-if="v.sectors[0]?.companyFormRequest">
                  <button
                    class="btn btn-air-info"
                    @click="v.isDatePickerOpen = !v.isDatePickerOpen"
                  >
                    Tarixi dəyiş
                  </button>
                  <div
                    v-if="v.isDatePickerOpen"
                    class="calendar-container mt-1"
                  >
                    <Datepicker
                      :value="v.sectors[0]?.companyFormRequest?.deadLineTime || Date.now()"
                      :monday-first="true"
                      @input="date => setDate(v.sectors[0].companyFormRequest.id, date)"
                    />
                  </div>
                </template>
                <!-- Əgər formRequest yoxdursa, amma expiryDate varsa -->
                <template v-else>
                  <button
                    class="btn btn-air-info"
                    @click="v.isDatePickerOpen = !v.isDatePickerOpen"
                  >
                    Tarixi dəyiş
                  </button>
                  <div
                    v-if="v.isDatePickerOpen"
                    class="calendar-container mt-1"
                  >
                    <Datepicker
                      :value="v.expiryDate || Date.now()"
                      :monday-first="true"
                      @input="date => setExpiryDate(v.id, date)"
                    />
                  </div>
                </template>
                <!-- Hər ikisi yoxdursa boş yer -->
              </div>


              <template v-if="v.sectors[0]?.companyFormRequest">
                <div
                  v-if="v.sectors[0]?.companyFormRequest?.status !== 'EXPIRED' && v.sectors[0]?.companyFormRequest?.deadLineTime"
                  class="col-md-2 text-right"
                >
                  <p class="font-weight-bold text-right text-black">
                    Yenilənmə tarixi:
                    {{ v.sectors[0]?.companyFormRequest?.deadLineTime || v.sectors[0]?.companyFormRequest?.sendTime }}
                  </p>

                  <button
                    v-if="v.sectors[0].companyFormRequest.deadLineTime && (new
                      Date(v.sectors[0].companyFormRequest.deadLineTime) - Date.now()) < (10 * 24 * 60 * 60 * 1000)"
                    :class="[
                      'btn',
                      'btn-sm',
                      'text-blink',
                      new Date(v.sectors[0].companyFormRequest.deadLineTime) < Date.now() ? 'btn-danger' : 'btn-success'
                    ]"
                    @click="recallVendor(v.sectors[0]?.companyFormRequest?.id)"
                  >
                    Forma yenilənmelidir
                  </button>
                </div>
                <div
                  v-else-if="v.sectors[0]?.companyFormRequest?.status === 'EXPIRED'"
                  class="col-md-2 text-center"
                >
                  Yenilənmə üçün göndərilmişdir
                </div>
                <div
                  v-else
                  class="col-md-2 text-right"
                />
              </template>
              <template v-else-if="v.expiryDate">
                <div class="col-md-2 text-right">
                  <p class="font-weight-bold text-right text-black">
                    Yenilənmə tarixi:
                    {{ v.expiryDate }}
                  </p>
                  <!-- İstəsək, expiryDate üçün də yeniləmə düyməsi əlavə etmək olar -->
                  <button
                    v-if="v.expiryDate && (new Date(v.expiryDate) - Date.now()) < (10 * 24 * 60 * 60 * 1000)"
                    :class="[
                      'btn',
                      'btn-sm',
                      'text-blink',
                      new Date(v.expiryDate) < Date.now() ? 'btn-danger' : 'btn-success'
                    ]"
                    @click="recallVendorExpiry(v.verifiedCompany.id,v.id)"
                  >
                    Forma yenilənmelidir
                  </button>
                </div>
              </template>
              <template v-else>
                <!-- Fallback: ensure we still render an empty col so layout remains consistent -->
                <div class="col-md-2 text-right" />
              </template>


              <!-- 5) Sil düyməsi -->
              <div class="col-md-1 text-right">
                <button
                  class="btn btn-danger btn-sm"
                  @click="deleteVendor(v.verifiedCompany.taxId)"
                >
                  {{ $t('general.delete') }}
                </button>
              </div>
            </div>

            <!-- 2-ci sətir (row) - CreatedBy məlumatı -->
            <div class="row mt-2">
              <div class="col-md-12">
                {{
                  $t('companyVendors.vcreatedbynameVcreatedbysurnameTrfindnNewDatevlogt', {
                    name: v.createdBy.name,
                    surname: v.createdBy.surname
                  })
                }}
              </div>
            </div>
          </div>
        </div>
      </div>

      <b-modal
        id="modal-vendor-request"
        size="xl"
        centered
        :title="$t('supplierOutgoingVendorRequest.mracitDetallar')"
        scrollable
        :hide-footer="true"
        class="theme-modal"
        :busy="false"
        :no-enforce-focus="true"
      >
        <VendorRequestDetailsReceiver
          v-if="activeRequestId>0"
          :active-request-id="activeRequestId"
          @confirmRequest="confirmRequest($event)"
        />
      </b-modal>


      <b-modal
        id="modal-request-confirm"
        size="lg"
        centered
        :title="$t('companyFormAdminView.mracitinTsdiqlnmsi')"
        scrollable
        :hide-footer="true"
        class="theme-modal"
        :busy="false"
        :no-enforce-focus="true"
        @close="getVendorList"
      >
        <ConfirmVendorRequestModal
          :confirm-request-details="confirmRequestDetails"
          @updated="showRequestDetails(confirmRequestDetails.requestId)"
        />
      </b-modal>
      <b-modal
        id="modal-add-vendor"
        size="md"
        centered
        :title="$t('vendorAddModal.addVendorTitle')"
        :busy="modalLoading"
        :hide-footer="true"
        @close="resetModal"
      >
        <div class="form-group">
          <label for="companyName">{{ $t('vendorAddModal.companyNameLabel') }}</label>
          <input
            id="companyName"
            v-model="searchForm.name"
            type="text"
            class="form-control"
            :placeholder="$t('vendorAddModal.companyNamePlaceholder')"
          >
        </div>
        <div class="form-group">
          <label for="taxId">{{ $t('vendorAddModal.taxIdLabel') }}</label>
          <input
            id="taxId"
            v-model="searchForm.taxId"
            type="text"
            class="form-control"
            :placeholder="$t('vendorAddModal.taxIdPlaceholder')"
          >
        </div>
        <button
          class="btn btn-primary"
          :disabled="modalLoading"
          @click="searchCompany"
        >
          {{ $t('vendorAddModal.searchButton') }}
        </button>

        <div
          v-if="companies?.length"
          class="mt-3"
        >
          <h5>{{ $t('vendorAddModal.searchResultsTitle') }}</h5>
          <ul class="list-group">
            <li
              v-for="company in companies"
              :key="company.id"
              :class="{'list-group-item': true, 'active': company.id === selectedCompanyId}"
              style="cursor: pointer"
              @click="selectCompany(company)"
            >
              {{ company.name }} ({{ company.taxId }})
            </li>
          </ul>
        </div>

        <!-- Profile Type and Sector Selection after Company Selection -->
        <div
          v-if="selectedCompanyId"
          class="mt-3"
        >
          <h5>{{ $t('vendorAddModal.selectProfileType') }}</h5>
          <div class="form-group">
            <label for="profileType">{{ $t('vendorAddModal.profileTypeLabel') }}</label>
            <select
              id="profileType"
              v-model="selectedProfileType"
              class="form-control"
              required
              @change="onProfileTypeChange"
            >
              <option value="SUPPLIER">
                {{ $t('vendorAddModal.profileTypeOptions.supplier') }}
              </option>
              <option value="LOGISTIC">
                {{ $t('vendorAddModal.profileTypeOptions.logistic') }}
              </option>
              <option value="TRUCK">
                {{ $t('vendorAddModal.profileTypeOptions.truck') }}
              </option>
            </select>
          </div>

          <!-- Sector Multiselect (visible only if profile type is SUPPLIER) -->
          <div
            v-if="selectedProfileType === 'SUPPLIER'"
            class="form-group"
          >
            <label>{{ $t('vendorAddModal.sectorLabel') }}</label>
            <Multiselect
              v-model="selectedSectors"
              :options="sectorListAdd"
              :multiple="true"
              :track-by="'id'"
              :label="'name'"
              :placeholder="$t('vendorAddModal.sectorPlaceholder')"
            />
          </div>
        </div>
        <button
          v-if="selectedCompanyId"
          class="btn btn-success mt-3"
          :disabled="!selectedCompanyId"
          @click="addCompanyToVendor"
        >
          {{ $t('vendorAddModal.saveToVendorButton') }}
        </button>
      </b-modal>
    </div>
  </div>
</template>
<script>
import {mapState} from "vuex";
import {mediaBase} from "@/repositories/Repository";
import {getWorkingSectors} from "@/repositories/GeneralDataRepository";
import {
  addCompanyToVendorManagment,
  addDeletedVendor,
  getVendorList,
  recallRequest,
  searchCompanyByNameOrTaxId,
  updateVendorDeadline,
  updateVendorExpiryDate,
} from "@/repositories/VendorManagementRepository";
import CompanyFormStatus from "@/pages/scc/vendorManagement/utils/CompanyFormStatus.vue";
import {getCompanyFormat, getPhoto} from "@/repositories/Utils";
import VendorRequestDetailsReceiver from "@/pages/scc/vendorManagement/VendorRequestDetailsReceiver.vue";
import ConfirmVendorRequestModal from "@/pages/scc/vendorManagement/ConfirmVendorRequestModal.vue";
import CompanyFormRequestStatus from "@/pages/scc/vendorManagement/utils/CompanyFormRequestStatus.vue";

import Multiselect from 'vue-multiselect'
import Datepicker from 'vuejs-datepicker';

export default {
  components: {
    Datepicker,
    CompanyFormRequestStatus,
    ConfirmVendorRequestModal,
    VendorRequestDetailsReceiver,
    CompanyFormStatus, Multiselect
  },
  data() {
    return {
      mediaBase: mediaBase,
      loaded: false,
      vendors: [],
      form: null,
      sectors: [],
      sections: [],
      inputs: [],
      faq: [],
      faqAnswerText: '',
      formLink: '',
      showCalendar: false,

      requests: [],
      activeRequestId: 0,
      confirmRequestDetails: null,
      sectorListAdd: [],

      sectorFilter: 0,
      profileTypeFilter: 'ALL',
      modalLoading: false,
      searchForm: {
        name: '',
        taxId: ''
      },
      companies: [],
      selectedCompanyId: null,
      selectedProfileType: 'SUPPLIER', // Default profile type
      selectedSectors: [], // Selected sectors when profile type is SUPPLIER
      vendorNameFilter: '',
      vendorSortOrder: 'asc'
    }
  },
  watch: {
    "$route"() {
      this.sectorFilter = parseInt(this.$route.query['sectorId'] || 0);
      this.profileTypeFilter = this.$route.query['profile'] || 'ALL';
    },
    profileTypeFilter() {
      if (this.profileTypeFilter !== 'SUPPLIER' && this.profileTypeFilter !== 'ALL') {
        this.sectorFilter = 0;
      }
    }
  },
  computed: {
    ...mapState({
      token: state => state.auth.token,
      user: state => state.auth.user,
    }),

    sectorList() {

      let map = {};

      this.vendors.forEach(v => {
        v.sectors.forEach(s => {
          map[s.sector.id] = s.sector;
        })
      })

      return Object.values(map);
    },

    filteredVendors() {

      let vendors = this.vendors;

      if (this.sectorFilter > 0) {
        vendors = this.vendors.filter((v) => {
          return v.sectors.filter(s => {
            return s.sector.id === this.sectorFilter;
          }).length > 0
        });
      }
      if (this.profileTypeFilter !== 'ALL') {
        vendors = this.vendors.filter((v) => {
          return v.profileType === this.profileTypeFilter;
        });
      }
      // Filter by vendor name (ignoring case)
      if (this.vendorNameFilter.trim() !== "") {
        const keyword = this.vendorNameFilter.toLowerCase();
        vendors = vendors.filter((v) =>
            v.verifiedCompany.name.toLowerCase().includes(keyword)
        );
      }

      // Sort vendors by verifiedCompany.name using selected order
      vendors.sort((a, b) => {
        const nameA = a.verifiedCompany.name.toLowerCase();
        const nameB = b.verifiedCompany.name.toLowerCase();

        if (nameA < nameB) return this.vendorSortOrder === 'asc' ? -1 : 1;
        if (nameA > nameB) return this.vendorSortOrder === 'asc' ? 1 : -1;
        return 0;
      });
      return vendors;

    }
  },
  mounted() {

    this.getVendorList();
    getWorkingSectors(this.$i18n.locale).then(ws => {
      this.sectorListAdd = ws.filter(s => s.parent === null);
    });
    this.sectorFilter = parseInt(this.$route.query['sectorId'] || 0);
    this.profileTypeFilter = this.$route.query['profile'] || 'ALL';
  },
  methods: {
    setExpiryDate(taxId, date) {
      const formattedDate = date?.toISOString().split('T')[0];
      updateVendorExpiryDate(this.token, taxId, formattedDate).then((response) => {
        if (response.code === 200) {
          this.$swal({icon: 'success', title: "Uğurla yeniləndi"});
          this.getVendorList();
        } else {
          this.$swal({icon: 'error', title: "Xəta baş verdi"});
        }
      });
    },

    // İstəsək, expiryDate üçün recall metodu da əlavə edilir
    recallVendorExpiry(companyId, vendorCompanyId) {
      this.$swal({
        title: "Diqqət",
        text: "Bir başa vendor Listə əlavə edilmiş tədarükçünün hansı forma ilə yenidən doldurulmasını seçmək üçün şirkət formlarından seçməlisiz. Davam edirsizmi?",
        icon: "info",
        showCancelButton: true,
        confirmButtonText: "Davam et",
        cancelButtonText: "Ləğv et",
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33'
      }).then((result) => {
        if (result.isConfirmed) {
          // Redirect to the vendor forms page
          window.location.href = "/dashboard/vendorManagement/forms";
        }
      });
    },
    setDate(id, date) {
      const formattedDate = date?.toISOString().split('T')[0];
      updateVendorDeadline(this.token, id, formattedDate).then((response) => {
        if (response.code === 200) {
          this.$swal({icon: 'success', title: "Uğurla yeniləndi"});
          this.getVendorList();
        } else {
          this.$swal({icon: 'error', title: "Xəta baş verdi"});
        }
      });
    },
    recallVendor(requestId) {
      this.$swal({
        text: "Yenilenme ucun gonderilsin?",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Bəli",
        cancelButtonText: this.$t("vendorManagementDeleted.cancel"),
        confirmButtonColor: '#d33',
        cancelButtonColor: '#3085d6'
      }).then((result) => {
        if (result.isConfirmed) {
          // Call recallRequest without a reason (empty string passed)
          recallRequest(this.token, requestId, 'Yenilenme vaxti')
              .then((response) => {
                if (response.code === 200) {
                  this.$swal(
                      this.$t("generalModal.successTitle"),
                      this.$t("Form renewed successfully"),
                      "success"
                  );
                  this.getVendorList(); // Refresh the vendor list if needed
                } else {
                  this.$swal(
                      this.$t("generalModal.errorTitle"),
                      response.message,
                      "error"
                  );
                }
              }).catch(error => {
            console.error("Error renewing form:", error);
            this.$swal(
                this.$t("generalModal.errorTitle"),
                this.$t("generalModal.errorOccurred"),
                "error"
            );
          });
        }
      });
    },
    deleteVendor(taxId) {
      this.$swal({
        title: this.$t("vendorManagementDeleted.deleteConfirm"),
        text: this.$t("vendorManagementDeleted.deleteVendorConfirm"),
        icon: "warning",
        input: "textarea",
        inputPlaceholder: this.$t("vendorManagementDeleted.reasonPlaceholder"),
        inputAttributes: {
          'aria-label': this.$t("general.reason")
        },
        showCancelButton: true,
        confirmButtonText: this.$t("general.delete"),
        cancelButtonText: this.$t("vendorManagementDeleted.cancel"),
        confirmButtonColor: '#d33',
        cancelButtonColor: '#3085d6',
        preConfirm: (reason) => {
          if (!reason) {
            this.$swal.showValidationMessage(this.$t("vendorManagementDeleted.reasonRequired"));
          }
          return reason;
        }
      }).then((result) => {
        if (result.isConfirmed && result.value) {
          const reason = result.value;
          addDeletedVendor(this.token, taxId, reason).then((response) => {
            if (response.code === 200) {
              this.$swal(this.$t("generalModal.successTitle"), this.$t("generalModal.deleted"), "success");
              this.getVendorList(); // Refresh the vendor list
            } else {
              this.$swal(this.$t("generalModal.errorTitle"), response.message, "error");
            }
          }).catch(error => {
            console.error("Error deleting vendor:", error);
            this.$swal(this.$t("generalModal.errorTitle"), this.$t("generalModal.errorOccurred"), "error");
          });
        }
      });
    }
    ,
    onProfileTypeChange() {
      if (this.selectedProfileType !== 'SUPPLIER') {
        this.selectedSectors = []; // Clear sectors if profile type is not SUPPLIER
      }
    },
    selectCompany(company) {
      this.selectedCompanyId = company.id; // Set selected company's ID
    },
    addVendorToList() {
      this.$bvModal.show('modal-add-vendor');

    },
    resetModal() {
      this.searchForm.name = '';
      this.searchForm.taxId = '';
      this.companies = [];
      this.modalLoading = false;
    },
    async searchCompany() {
      if (this.searchForm.name === '' && this.searchForm.taxId === '') {
        this.$swal({
          title: this.$t("generalModal.warningTitle"),
          icon: "error",
          text: this.$t("vendorAddModal.searchError")
        });
        return;
      } else if (this.searchForm.name?.length < 3 && this.searchForm.taxId === '') {
        this.$swal({
          title: this.$t("generalModal.warningTitle"),
          icon: "error",
          text: "Şirkətın adı 3 hərfdən az ola bilməz"
        });
        return;
      }
      this.modalLoading = true;
      try {
        // Call the async function to fetch company data
        searchCompanyByNameOrTaxId(this.token, this.searchForm.name, this.searchForm.taxId).then(data => {
          this.companies = data.companies;
        })

      } catch (error) {
        console.error("Error searching for company:", error);
        this.companies = [];
      } finally {
        this.modalLoading = false;
      }
    },
    getCompanyFormat(keyword) {
      return getCompanyFormat(keyword, this.$i18n.locale);
    },
    addCompanyToVendor() {
      if (this.selectedSectors.length === 0) {
        this.$swal({
          title: this.$t("generalModal.warningTitle"),
          icon: "error",
          text: "Fəaliyyət sahələrini seçmək mütləqdir!"
        });
        return;
      }
      let sectors = this.selectedSectors.map(function (elem) {
        return elem.id;
      }).join(",");

      addCompanyToVendorManagment(this.token, this.selectedCompanyId, this.selectedProfileType, sectors).then(data => {
        if (data.code === 200) {
          this.$swal({
            title: this.$t("generalModal.successTitle"),
            icon: 'success'
          }).then(() => {
            window.location.reload();
          })
        } else if (data.code === 406) {
          this.$swal({
            title: this.$t("generalModal.warningTitle"),
            text: 'Bu şirkət sizin şirkətin tədarükçü siyahısından çıxarılmışlar siyahısındadır',
            icon: 'warning'
          })
        } else
          this.$swal({
            title: this.$t("generalModal.errorTitle"),
            text: data.message,
            icon: 'error'
          })
      })
    },
    getPhoto(path, size) {
      return getPhoto(path, size);
    },

    getVendorList() {

      getVendorList(this.token).then((list) => {
        this.loaded = true;
        this.vendors = list.map(vendor => ({...vendor, isDatePickerOpen: false}));

      });

    },


    showRequestDetails(id) {
      this.activeRequestId = id;
      this.$bvModal.show('modal-vendor-request');
    },

    confirmRequest(data) {
      this.confirmRequestDetails = data;
      this.$bvModal.hide('modal-vendor-request');
      this.$bvModal.show('modal-request-confirm')
    },


  }

}
</script>
<style>
@keyframes blink {
  0% {
    opacity: 1;
  }
  50% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}

.text-blink {
  animation: blink 1s infinite;
}
</style>